import React, { Component } from 'react';
import './WaitingForEmr.scss';
import waitGraphic from './WaitingForEmr.svg';
import '../../../styles/cidMobile.scss';
import FooterMobile from '../../../shared/FooterMobile/FooterMobile';

/**
* WaitingForEmr screen
* @class WaitingForEmr
* @extends {Component}
*/
class WaitingForEmr extends Component {
  render() {
    return (
      <div className='cidMobile'>
        <div className='waitContent'>
          <img src={waitGraphic} className='waitGraphic' alt='mobile device'/>
          <div className='waitingForEmrText'><h1>Waiting for EMR to respond</h1></div>
        </div>
        {/* This page is for mobile only, so we only need the mobile footer. */}
        <FooterMobile/>
      </div>
    );
  }
}

export default WaitingForEmr;
